import { faArrowRight, faDownload, faPen, faPlus, faTrash } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { FC, useEffect, useState } from "react"
import { Button, ButtonGroup, Card, Dropdown } from "react-bootstrap"
import CustomFileView from "../../../common/components/CustomFileView/CustomFileView"
import { IFile } from "../../../interfaces/File"
import { ITeacherFile } from "../../../interfaces/TeacherFile"
import fileService from "../../../services/FileService"
import teacherFileService from "../../../services/TeacherFileService"
import TeacherFileModal from "./TeacherFileModal"

const TeacherFile: FC<{ teacherId: number, reload?: (reload: boolean) => void }> = (props) => {

    // generic data
    const { teacherId, reload } = props
    const [files, setFiles] = useState<ITeacherFile[]>([])
    const [refresh, setRefresh] = useState(false);

    // modal
    const [showModal, setShowModal] = useState(false);
    const [currentTeacherFile, setCurrentTeacherFile] = useState<ITeacherFile | undefined>(undefined)
    const [currentFile, setCurrentFile] = useState<IFile | undefined>(undefined)
    const [currentId, setCurrentId] = useState<number | undefined>(undefined);
    const [action, setAction] = useState('');

    useEffect(() => {
        teacherFileService.getAll(teacherId).then(
            files => setFiles(files)
        )
    }, [teacherId])

    useEffect(() => {
        if (refresh === true && teacherId) {
            if (reload)
                reload(true)
            teacherFileService.getAll(teacherId).then(
                files => {
                    setFiles(files)
                    setRefresh(false);
                }
            )
        }
    }, [refresh, reload, teacherId]);

    const onPreviewFile = (file?: ITeacherFile) => {
        if (file)
            fileService.preview(file.file.id)
    }

    const onDownloadFile = (file?: ITeacherFile) => {
        if (file)
            fileService.download(file.file.id)
    }

    const onAddClick = () => {
        setAction('add');
        setShowModal(true);
    }

    const onDeleteClick = (file: ITeacherFile) => {
        if (file) {
            setAction('delete')
            setCurrentTeacherFile(file)
            setCurrentId(file.id)
            setShowModal(true);
        }
    }

    const onEditClick = (file: ITeacherFile) => {
        fileService.get(file.file.id)
            .then(
                res => {
                    setAction('edit');
                    setCurrentFile(res);
                    setCurrentId(res.id);
                    setShowModal(true);
                }
            )
    }

    return <div className="d-flex flex-column pt-3">
        <TeacherFileModal
            teacherFile={currentTeacherFile}
            teacherId={teacherId}
            currentFile={currentFile}
            id={currentId}
            show={showModal}
            close={(action?: string) => {
                setShowModal(false);
                setAction('')
                setCurrentTeacherFile(undefined)
                setCurrentFile(undefined);
                setCurrentId(undefined);
                if (typeof action === 'string')
                    setRefresh(true);
            }}
            action={action}
        />
        <Card className="shadow-sm h-100">
            <Card.Header className="d-flex align-items-center justify-content-between">
                <span className="fw-600">Allegati</span>
                <button className='btn btn-success rounded-pill d-flex align-items-center' onClick={onAddClick}><FontAwesomeIcon icon={faPlus} className="me-1" />Aggiungi</button>
            </Card.Header>
            {
                files.length > 0 ? <Card.Body>
                    {
                        files.map(file => <div key={file.id} className="d-flex col-12 align-items-center">
                            <div className="col-3">
                                <Dropdown as={ButtonGroup} className="shadow-sm">
                                    <Button className='btn btn-light' onClick={() => onPreviewFile(file)}>
                                        <CustomFileView file={file.file} />
                                    </Button>
                                    <Dropdown.Toggle split id="dropdown-split-basic" className='btn btn-light' />
                                    <Dropdown.Menu>
                                        <Dropdown.Item onClick={() => onPreviewFile(file)}><FontAwesomeIcon icon={faArrowRight} className="me-1" />Anteprima</Dropdown.Item>
                                        <Dropdown.Item onClick={() => onDownloadFile(file)}><FontAwesomeIcon icon={faDownload} className="me-1" />Download</Dropdown.Item>
                                        <Dropdown.Item onClick={() => onEditClick(file)}><FontAwesomeIcon icon={faPen} className="me-1" />Modifica</Dropdown.Item>
                                        <Dropdown.Item onClick={() => onDeleteClick(file)}><FontAwesomeIcon icon={faTrash} className="me-1" />Elimina</Dropdown.Item>
                                    </Dropdown.Menu>
                                </Dropdown>
                            </div>
                            <Card.Text className="col-9 ms-2">
                                {file.file.description || '-'}
                            </Card.Text>
                        </div>
                        )
                    }
                </Card.Body> : null
            }
        </Card>
    </div>
}

export default TeacherFile; 